import React, { useEffect } from 'react';
import ReactMarkdown from 'react-markdown';

import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

const ContentSlider = ({ content, images, cote, width, height }) => {
  useEffect(() => {
    Fancybox.bind("[data-fancybox='gallery']", {});
    return () => {
      Fancybox.destroy();
    };
  }, [images]);

  // Fonction utilitaire pour convertir les chemins relatifs "../" en "/"
  const cleanPath = (path) => path.replace(/^\.\.\/+/, '/');

  return (
    <div className={`container-content ${cote}`}>
      <div className="content markdown">
        <ReactMarkdown>{content}</ReactMarkdown>
      </div>

      <div className="image-slider">
        <Swiper
          modules={[Navigation, Pagination]}
          spaceBetween={30}
          slidesPerView={1}
          navigation
          pagination={{ clickable: true }}
          loop={true}
          autoHeight={true}
        >
          {images && images.length > 0 ? (
            images.map((img, index) => (
              <SwiperSlide key={index}>
                <a
                  href={cleanPath(img.hd || img.src)}
                  data-fancybox="gallery"
                  data-caption={img.alt || `Image ${index + 1}`}
                >
                  <img
                    src={cleanPath(img.thumb || img.src)}
                    alt={img.alt || `Slide ${index + 1}`}
                    loading="lazy"
                    style={{ width: img.width || '100%', height: img.height || 'auto' }}
                  />
                </a>
              </SwiperSlide>
            ))
          ) : (
            <p>Aucune image à afficher.</p>
          )}
        </Swiper>
      </div>
    </div>
  );
};

export default ContentSlider;
